import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthGroupService } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.service';
import { InitializeAuthGroupSignal } from 'apps/hospital-admin/src/app/auth-group/+state/auth-group.signals';
import { AUTH_GROUPS } from 'apps/hospital-admin/src/app/auth-group/constants';
import { filter, switchMap, tap } from 'rxjs';

export const controlAdminGuard: CanActivateFn = () => {
  const authGroupService = inject(AuthGroupService);
  const router = inject(Router);
  const store = inject(Store);

  store.dispatch(new InitializeAuthGroupSignal({}));

  return authGroupService
    .isLoaded()
    .pipe(
      filter((isLoaded) => isLoaded),
      switchMap(() =>
        authGroupService.getOfficerBelongsToAnyOfTheAuthGroups([
          AUTH_GROUPS.LOCUMS_CONTROL_ADMIN,
          AUTH_GROUPS.CUSTOMER_ADMIN,
        ]),
      ),
    )
    .pipe(tap((hasGroup) => hasGroup || router.navigateByUrl('dashboard')));
};
